// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rW-O","inner":"styles_inner__1dPsj","right":"styles_right__25TRj","close":"styles_close__S3CE-","footer":"styles_footer__1t1te"};